import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  PATCH: 'LEARNOSITY_SESSION_PATCH',
  PATCH_SUCCESS: 'LEARNOSITY_SESSION_PATCH_SUCCESS',
  PATCH_FAILURE: 'LEARNOSITY_SESSION_PATCH_FAILURE',
};

export const patch = actions.patch(
  sessionId => `${BASE_URL}/curriculum/learnosity-sessions/${sessionId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
